import { render, staticRenderFns } from "./AmountTable.vue?vue&type=template&id=3e3c80ee&scoped=true&"
import script from "./AmountTable.vue?vue&type=script&lang=js&"
export * from "./AmountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c80ee",
  null
  
)

export default component.exports